/**
* 分页组件
*/
<template>
  <el-pagination v-if="total>0" class="page-box" @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 background
                 layout="total,  prev, pager, next, jumper"
                 :current-page.sync="currentPage"
                 :page-size="limit"
                 :total="total"
                 >
  </el-pagination>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    // 避免直接改变prop属性
    // 'currentPage': {
    //   required: false,
    //   default: 1
    // },
    'total': {
      required: false,
      default: 0
    },
    'limit': {
      required: false,
      default: 10
    },
    'small': {
      required: false,
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentPage(val) {
      // 改变这个值并不会触发 handleCurrentChange
      if (typeof val === "number") {
        console.log('prop currentPage!!!');
        this.currentPage = val;
      }
    },
  },
  data() {
    return {
      currentPage: 1
    }
  },
  created() {},
  methods: {
    handleSizeChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.currentPage = 1;
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>

<style scoped>
.page-box {
  margin: 30px auto 0;
  text-align: center;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #2b52e9;
}
.page-box >>> .active{
  background: #ebf2fc!important;
  color: #2b51e8!important;
  border: 1px solid #2b51e8!important;
}
.page-box>>>.el-input__inner{
  width: 39px;
  height: 25px;
  border: 1px solid #cccccc;
}
.page-box>>>.el-input__inner:hover{
  border: 1px solid #b0bceb;
}
.page-box>>>.el-input__inner:focus{
  border:1px solid #2b52e9;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue